module.exports = __webpack_public_path__ + "static/media/game(10).94b0a6fb.PNG";